export default __webpack_public_path__ + "static/media/abba.2a3cbf66.png";